export default __webpack_public_path__ + "static/media/permanent_life_light.8679a8fc.png";